export default /* glsl */`
precision highp float;

#include <gradient_pars_frag>
#include <resolution_pars_common>

uniform float aspect;
uniform highp float progress;

#include <smoothmix_func>
#include <noise_func>
#include <gradient_linear_func>

void main() {

    #include <gradient_linear_progress_color>

    gl_FragColor = vec4(color, 1.);

}
`;
